import { render, staticRenderFns } from "./QuizResultSelector.vue?vue&type=template&id=280c9fe4&"
import script from "./QuizResultSelector.vue?vue&type=script&lang=js&"
export * from "./QuizResultSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports